<script setup>
import Panel from "@components/activities/Panel.vue";
</script>

<template>
    <div class="contents">
        <Panel />
    </div>
</template>
